import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { FeatureDirectDebitTranslationDictionary } from '../models/i18n/feature-direct-debit-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureDirectDebitTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      DIRECT_DEBIT_DG_TITLE_BOILERS: 'Domestic & General Services Limited',
      DIRECT_DEBIT_DG_TITLE_WHITE_GOODS: 'Domestic & General Insurance PLC',
      DIRECT_DEBIT_FORM_ACCOUNT_HOLDER_CONFIRMATION_ERROR_REQUIRED:
        'Please check the box to confirm that your information is correct',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_REQUIRED:
        'Please enter the name of the account holder',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_MIN_LENGTH:
        'Account number should contain {{ minLength }} digits',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_PATTERN:
        'Please enter a valid account number',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_REQUIRED:
        'Please enter an account number',
      DIRECT_DEBIT_FORM_EDIT_DIRECT_DEBIT_DETAILS_CANCEL: 'Cancel changes',
      DIRECT_DEBIT_FORM_EDIT_DIRECT_DEBIT_DETAILS: 'Change payment details',
      DIRECT_DEBIT_FORM_IBAN_ERROR_REQUIRED: 'Please enter an IBAN',
      DIRECT_DEBIT_FORM_IBAN_ERROR_PATTERN: 'Please enter a valid IBAN',
      DIRECT_DEBIT_FORM_LEGAL_DOCUMENT_INSURANCE_PRODUCT_INFORMATION_DOCUMENT:
        'Insurance Product Information Document',
      DIRECT_DEBIT_FORM_LEGAL_DOCUMENT_TERMS_AND_CONDITIONS:
        'Terms & Conditions',
      DIRECT_DEBIT_FORM_PAYMENT_DATE_ERROR_REQUIRED:
        'Please enter a payment date',
      DIRECT_DEBIT_FORM_REQUIRED_FIELD: '* Required field',
      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_SUBTITLE:
        'You can use these payment details or change them below.',
      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_SUBTITLE_WHEN_EDITING:
        'You can use this payment method or change it below.',
      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_TITLE: 'Your payment details',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_MIN_LENGTH:
        'Sort code should contain {{ minLength }} digits',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_PATTERN:
        'Please enter a valid sort code',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_REQUIRED: 'Please enter the sort code',
      DIRECT_DEBIT_FORM_TERMS_AND_CONDITIONS_ERROR_REQUIRED:
        'Please tick the box to confirm you have read the Insurance Product Information Document',
      DIRECT_DEBIT_FORM_SUBMIT_BUTTON: 'Confirm & Pay',
      DIRECT_DEBIT_INVALID_ACCOUNT_DETAILS_ERROR:
        'Invalid account details combination',
      DIRECT_DEBIT_FORM_FIRST_MONTH_PAYMENT:
        'Your first month is free, your following payment is {{ quote }} unless cancelled.',
      DIRECT_DEBIT_FORM_VARIABLE_PROMOTION_PAYMENT:
        'Your first {{ monthsFree }} are free, your following payment is {{ quote }} unless cancelled.',
      DIRECT_DEBIT_DETAILS_SUBTITLE:
        'When you pay by Direct Debit, your plan will automatically renew each year, ensuring there’s no break in protection.',
    },
    [LocaleId.English_Ireland]: {
      DIRECT_DEBIT_DG_TITLE_BOILERS: 'Domestic & General Services Limited',
      DIRECT_DEBIT_DG_TITLE_WHITE_GOODS: 'Domestic & General Insurance PLC',
      DIRECT_DEBIT_FORM_ACCOUNT_HOLDER_CONFIRMATION_ERROR_REQUIRED:
        'Please check the box to confirm that your information is correct',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_REQUIRED:
        'Please enter the name of the account holder',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_MIN_LENGTH:
        'Account number should contain {{ minLength }} digits',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_PATTERN:
        'Please enter a valid account number',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_REQUIRED:
        'Please enter an account number',
      DIRECT_DEBIT_FORM_EDIT_DIRECT_DEBIT_DETAILS_CANCEL: 'Cancel changes',
      DIRECT_DEBIT_FORM_EDIT_DIRECT_DEBIT_DETAILS: 'Change payment details',
      DIRECT_DEBIT_FORM_PAYMENT_DATE_ERROR_REQUIRED:
        'Please enter a payment date',
      DIRECT_DEBIT_FORM_IBAN_ERROR_REQUIRED: 'Please enter an IBAN',
      DIRECT_DEBIT_FORM_IBAN_ERROR_PATTERN: 'Please enter a valid IBAN',
      DIRECT_DEBIT_FORM_LEGAL_DOCUMENT_INSURANCE_PRODUCT_INFORMATION_DOCUMENT:
        'Insurance Product Information Document',
      DIRECT_DEBIT_FORM_LEGAL_DOCUMENT_TERMS_AND_CONDITIONS:
        'Terms & Conditions',
      DIRECT_DEBIT_FORM_REQUIRED_FIELD: '* Required field',
      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_SUBTITLE:
        'You can use these payment details or change them below.',
      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_SUBTITLE_WHEN_EDITING:
        'You can use this payment method or change it below.',

      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_TITLE: 'Your payment details',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_MIN_LENGTH:
        'Sort code should contain {{ minLength }} digits',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_PATTERN:
        'Please enter a valid sort code',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_REQUIRED: 'Please enter the sort code',
      DIRECT_DEBIT_FORM_TERMS_AND_CONDITIONS_ERROR_REQUIRED:
        'Please tick the box to confirm you have read the Insurance Product Information Document',
      DIRECT_DEBIT_FORM_SUBMIT_BUTTON: 'Confirm & Pay',
      DIRECT_DEBIT_INVALID_ACCOUNT_DETAILS_ERROR:
        'Invalid account details combination',
      DIRECT_DEBIT_FORM_FIRST_MONTH_PAYMENT:
        'Your first month is free, your following payment is {{ quote }} unless cancelled.',
      DIRECT_DEBIT_FORM_VARIABLE_PROMOTION_PAYMENT:
        'Your first {{monthsFree}} are free, your following payment is {{ quote }} unless cancelled.',
      DIRECT_DEBIT_DETAILS_SUBTITLE:
        'When you pay by Direct Debit, your plan will automatically renew each year, ensuring there’s no break in protection.',
    },
    [LocaleId.English_US]: {
      DIRECT_DEBIT_DG_TITLE_BOILERS: 'Domestic & General Services Limited',
      DIRECT_DEBIT_DG_TITLE_WHITE_GOODS: 'Domestic & General Insurance PLC',
      DIRECT_DEBIT_FORM_ACCOUNT_HOLDER_CONFIRMATION_ERROR_REQUIRED:
        'Please check the box to confirm that your information is correct',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_ALPHABETICAL:
        'Please enter an alphabetical value',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_MAX_LENGTH:
        'Please enter a value that is no more than {{ maxLength }} characters',
      DIRECT_DEBIT_FORM_ACCOUNT_NAME_ERROR_REQUIRED:
        'Please enter the name of the account holder',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_MIN_LENGTH:
        'Account number should contain {{ minLength }} digits',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_PATTERN:
        'Please enter a valid account number',
      DIRECT_DEBIT_FORM_ACCOUNT_NUMBER_ERROR_REQUIRED:
        'Please enter an account number',
      DIRECT_DEBIT_FORM_EDIT_DIRECT_DEBIT_DETAILS_CANCEL: 'Cancel changes',
      DIRECT_DEBIT_FORM_EDIT_DIRECT_DEBIT_DETAILS: 'Change payment details',
      DIRECT_DEBIT_FORM_PAYMENT_DATE_ERROR_REQUIRED:
        'Please enter a payment date',
      DIRECT_DEBIT_FORM_IBAN_ERROR_REQUIRED: 'Please enter an IBAN',
      DIRECT_DEBIT_FORM_IBAN_ERROR_PATTERN: 'Please enter a valid IBAN',
      DIRECT_DEBIT_FORM_LEGAL_DOCUMENT_INSURANCE_PRODUCT_INFORMATION_DOCUMENT:
        'Insurance Product Information Document',
      DIRECT_DEBIT_FORM_LEGAL_DOCUMENT_TERMS_AND_CONDITIONS:
        'Terms & Conditions',
      DIRECT_DEBIT_FORM_REQUIRED_FIELD: '* Required field',
      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_SUBTITLE:
        'You can use these payment details or change them below.',
      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_SUBTITLE_WHEN_EDITING:
        'You can use this payment method or change it below.',
      DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_TITLE: 'Your payment details',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_MIN_LENGTH:
        'Sort code should contain {{ minLength }} digits',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_PATTERN:
        'Please enter a valid sort code',
      DIRECT_DEBIT_FORM_SORT_CODE_ERROR_REQUIRED: 'Please enter the sort code',
      DIRECT_DEBIT_FORM_TERMS_AND_CONDITIONS_ERROR_REQUIRED:
        'Please tick the box to confirm you have read the Insurance Product Information Document',
      DIRECT_DEBIT_FORM_SUBMIT_BUTTON: 'Confirm & Pay',
      DIRECT_DEBIT_INVALID_ACCOUNT_DETAILS_ERROR:
        'Invalid account details combination',
      DIRECT_DEBIT_FORM_FIRST_MONTH_PAYMENT:
        'Your first month is free, your following payment is {{ quote }} unless cancelled.',
      DIRECT_DEBIT_FORM_VARIABLE_PROMOTION_PAYMENT:
        'Your first {{monthsFree}} are free, your following payment is {{ quote }} unless cancelled.',
      DIRECT_DEBIT_DETAILS_SUBTITLE:
        'When you pay by Direct Debit, your plan will automatically renew each year, ensuring there’s no break in protection.',
    },
  };
